import { Component, Input, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { Achivement } from 'src/app/Models/archivementmaster';
import { ApiService } from 'src/app/Service/api.service';

@Component({
  selector: 'app-archivementmaster',
  templateUrl: './archivementmaster.component.html',
  styleUrls: ['./archivementmaster.component.css']
})
export class ArchivementmasterComponent implements OnInit {
  @Input() drawerClose: Function;
  @Input() data: Achivement;
    isSpinning = false
  logtext:string = "";
visi:boolean=true
changes:boolean=false
icons=''
change(event:any)
{
this.changes=true
this.icons=event

}
go(url:string)
{
  this.visi=false
  window.open(url,"_blank")
}

  constructor(private api: ApiService, private message: NzNotificationService) {
  }

  ngOnInit() {
  
  }
  


  close(): void {
    this.drawerClose();

	this.logtext = 'CLOSED - Achivement form';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

  }

  save(addNew: boolean): void {
    var isOk = true
    if (this.data.TITLE == undefined || this.data.TITLE=="") {
      this.message.error("Please Enter Title" , "");
      isOk = false
    }
    
    if (this.data.DESCRIPTION == undefined || this.data.DESCRIPTION=="") {
      this.message.error("Please Enter Description" , "");
      isOk = false
    }
    if (this.data.ICON == undefined || this.data.ICON=="") {
      this.message.error("Please Enter Icon" , "");
      isOk = false
    }
    if (this.data.SEQUENCE_NO == undefined || this.data.SEQUENCE_NO==0) {
      this.message.error("Please Enter Sequence No." , "");
      isOk = false
    }
    if(isOk){
    
    
    

    this.isSpinning = true;
  
      if (this.data.ID) {

	

        this.api.updateAchivement(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Achivement information updated Successfully...", "");

	this.logtext = 'Update & Close - Achivement form - SUCCESS '+ JSON.stringify(this.data)+" KEYWORD [U - Achivement ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              if (!addNew)
                this.drawerClose();
              this.isSpinning = false;
            }
            else {

	this.logtext = 'Update & Close - Achivement form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [U - Achivement ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              this.message.error("Failed to update achivement information...", "");
              this.isSpinning = false;
            }
          });
      }
      else {

        this.api.createAchivement(this.data)
          .subscribe(successCode => {
            if (successCode['code'] == "200") {
              this.message.success("Achivement information added successfully...", "");

              if (!addNew)
	{
                this.drawerClose();

	this.logtext = 'Save & Close - Achivement form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Achivement ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
	}

              else {
                this.data = new Achivement();
	this.logtext = 'Save & New - Achivement form - SUCCESS - '+ JSON.stringify(this.data)+" KEYWORD [C - Achivement ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });

              }
              this.isSpinning = false;
            }
            else {
              this.message.error("Failed to add achivement information...", "");
	this.isSpinning = false;
	this.logtext = 'Save & Close - Achivement form - ERROR - '+ JSON.stringify(this.data)+" KEYWORD [C - Achivement ]";
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
              
            }
          });
      }
  }
}


}